import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { ThemeProvider } from "@/theme";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "sonner";

// Guard: redirect to login if no session hint exists.
// Actual auth is enforced by the httpOnly cookie on every API call.
function ProtectedRoute({ children }) {
  const isLoggedIn = sessionStorage.getItem("infraai_logged_in") === "true";
  if (!isLoggedIn) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster
            position="bottom-right"
            toastOptions={{
              className: "!bg-bg-paper !border !border-line !text-ink",
              style: { fontFamily: "Chivo, sans-serif" },
            }}
          />
        </BrowserRouter>
      </I18nProvider>
    </ThemeProvider>
  );
}
